export const sharedThemeSettings = {
  palette: {
    primaryReverse: {
      light: "#000000",
      main: "#e0e0e0",
      dark: "#e0e0e0",
      pale: "#d5d8d9",
      contrastText: "#33373B"
    },
    error: {
      main: "#ED0000",
      contrastText: "#fff"
    },
    warning: {
      main: "#FFD84E",
      light: "#dbc188",
      secondary: "#fff6e6",
      contrastText: "#fff"
    },
    info: {
      main: "#000FF0"
    },
    success: {
      main: "#9EFF00",
      secondary: "#6ba53a",
      contrastText: "#fff"
    },
    secondaryButton: {
      main: "#fff",
      contrastText: "#000"
    },
    diagramColors: {
      warning: "#ffa200",
      error: "#ff0000",
      info: "#005db9",
      success: "#8fd400",
      default: "#000000",
    },
  }
}